import { render } from "./CompanyRedirectAdd.vue?vue&type=template&id=6c03444e"
import script from "./CompanyRedirectAdd.vue?vue&type=script&lang=js"
export * from "./CompanyRedirectAdd.vue?vue&type=script&lang=js"

import "./CompanyRedirectAdd.vue?vue&type=style&index=0&id=6c03444e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__